<template>
  <!--
    	描述：获取谷歌地图的坐标
    -->
  <div class="getpoint-container">
    <!-- 搜索框 -->
    <div class="search-container">
      <input
        ref="searchInput"
        v-model="searchValue"
        class="search-input"
        placeholder="搜索地点..."
        @keyup="keyupFunc"
        @input="onSearchInput"
      />
      <button @click="searchFunc" class="search-btn">搜索</button>
    </div>

    <div class="pr map-container">
      <div id="mapContainer"></div>
      <!--搜索建议-->
      <div v-if="searchWordList.length > 0" class="search-suggestions">
        <div
          v-for="(item, index) in searchWordList"
          :key="index"
          class="suggestion-item"
          @click="chooseSuggestion(item)"
        >
          {{ item.description }}
        </div>
      </div>

      <!--搜索出来的地方-->
      <div :class="searchList.length > 0 ? 'map-city-list open' : 'map-city-list'">
        <div :class="select_address == index ? 'd-s-s item active' : 'd-s-s item'" v-for="(item, index) in searchList" :key="index" @click="choseItem(item, index)">
          <span class="index-box">{{ index + 1 }}</span>
          <div class="flex-1">
            <p class="title">{{ item.name || item.title }}</p>
            <p class="address">{{ item.formatted_address || item.address }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import marker10 from '@/assets/img/marker10.png';

export default {
  data() {
    return {
      /*背景图片*/
      marker10_url: marker10,
      /*地图缩放层级*/
      zoom: 10,
      /*地图对象*/
      map: null,
      /*谷歌地图API对象*/
      google: null,
      /*搜索结果*/
      searchList: [],
      /*选择的地址*/
      select_address: null,
      /*当前城市*/
      select_city: null,
      /*城市列表是否显示*/
      is_city: false,
      /*关键字*/
      searchValue: '',
      /*搜索字母*/
      searchWord: '',
      /*键盘事件搜索的数据*/
      searchWordList: [],
      /*选择搜索出来的数据列表*/
      searchlist_index: null,
      /*图标临时对象*/
      marker_temp: null,
      /*谷歌地图标记数组*/
      markers: [],
      /*地理编码服务*/
      geocoder: null,
      /*地点服务*/
      placesService: null,
      /*自动完成服务*/
      autocompleteService: null,
      /*是否已经设置了初始位置*/
      hasSetInitialLocation: false
    };
  },
  props: {
    form: Object,
    initialLocation: {
      type: Object,
      default: null
    }
  },
  watch: {
    /* 监听初始位置变化 */
    initialLocation: {
      handler(newLocation) {
        if (newLocation && this.map) {
          this.displayInitialLocation(newLocation);
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initGoogleMaps();
  },
  methods: {
    /*初始化谷歌地图*/
    initGoogleMaps() {
      const self = this;

      // 检查谷歌地图API是否已加载
      if (typeof google === 'undefined' || !google.maps) {
        this.$message.error('谷歌地图API未加载，请检查API密钥配置');
        return;
      }

      // 初始化地图，如果有初始位置则使用初始位置作为中心点
      const mapCenter = this.initialLocation 
        ? { lat: this.initialLocation.lat, lng: this.initialLocation.lng }
        : { lat: 39.916527, lng: 116.397128 }; // 默认北京坐标
      
      this.map = new google.maps.Map(document.getElementById('mapContainer'), {
        center: mapCenter,
        zoom: this.initialLocation ? 15 : 8, // 如果有初始位置则放大显示
        cursor: 'crosshair'
      });

      // 初始化地理编码服务
      this.geocoder = new google.maps.Geocoder();

      // 初始化地点服务
      this.placesService = new google.maps.places.PlacesService(this.map);

      // 初始化自动完成服务
      this.autocompleteService = new google.maps.places.AutocompleteService();

      // 只有在没有初始位置时才获取用户当前位置
      if (!this.initialLocation && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            // 如果已经设置了初始位置，不要覆盖
            if (self.hasSetInitialLocation) return;
            
            const userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            self.map.setCenter(userLocation);
            self.map.setZoom(13);
          },
          function() {
            // 如果已经设置了初始位置，不要覆盖
            if (self.hasSetInitialLocation) return;
            
            // 如果获取位置失败，使用默认位置
            self.map.setCenter({ lat: 39.916527, lng: 116.397128 });
            self.map.setZoom(13);
          }
        );
      } else if (!this.initialLocation) {
        // 如果没有初始位置且不支持定位，使用默认位置
        self.map.setCenter({ lat: 39.916527, lng: 116.397128 });
        self.map.setZoom(13);
      }

      // 绑定单击地图事件
      google.maps.event.addListener(this.map, 'click', function(event) {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();

        // 使用地理编码服务获取地址信息
        self.geocoder.geocode(
          { location: { lat: lat, lng: lng } },
          function(results, status) {
            if (status === 'OK' && results[0]) {
              const result = {
                location: { lat: lat, lng: lng },
                formatted_address: results[0].formatted_address,
                name: results[0].formatted_address,
                address: results[0].formatted_address, // 兼容原来的 address 属性
                title: results[0].formatted_address, // 兼容原来的 title 属性
                address_components: results[0].address_components
              };
              console.log('点击地图选择 result', result);
              self.$emit('chose', result);
            }
          }
        );
      });

      // 获取地图缩放层级
      google.maps.event.addListener(this.map, 'zoom_changed', function() {
        self.zoom = self.map.getZoom();
      });

      this.google = google;
      
      // 如果有初始位置，显示它
      if (this.initialLocation) {
        this.displayInitialLocation(this.initialLocation);
      }
    },

    /*显示初始位置*/
    displayInitialLocation(location) {
      if (!this.map || !location) return;
      
      const position = {
        lat: location.lat,
        lng: location.lng
      };
      
      // 设置地图中心点到初始位置
      this.map.setCenter(position);
      this.map.setZoom(15);
      
      // 标记已经设置了初始位置
      this.hasSetInitialLocation = true;
      
      // 创建初始位置标记
      if (this.marker_temp) {
        this.marker_temp.setMap(null);
      }
      
      this.marker_temp = new google.maps.Marker({
        position: position,
        map: this.map,
        title: location.name || '店铺位置',
        icon: {
          url: this.marker10_url,
          scaledSize: new google.maps.Size(27, 33),
          anchor: new google.maps.Point(13, 33)
        },
        zIndex: 1000
      });
      
      // 添加信息窗口显示店铺信息
      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div style="padding: 10px; min-width: 200px;">
            <h4 style="margin: 0 0 8px 0; color: #333;">${location.name || '店铺位置'}</h4>
            <p style="margin: 0 0 8px 0; color: #666; font-size: 12px;">${location.address || ''}</p>
            <div style="margin-top: 8px;">
              <a href="https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}" 
                 target="_blank" 
                 style="background: #4285f4; color: white; padding: 6px 12px; text-decoration: none; border-radius: 4px; font-size: 12px;">
                🧭 导航到这里
              </a>
            </div>
          </div>
        `
      });
      
      // 点击标记显示信息窗口
      this.marker_temp.addListener('click', () => {
        infoWindow.open(this.map, this.marker_temp);
      });
      
      // 如果是初始位置，自动显示信息窗口
      if (location.isInitial) {
        setTimeout(() => {
          infoWindow.open(this.map, this.marker_temp);
        }, 1000);
      }
    },

    /*选择搜索建议*/
    chooseSuggestion(item) {
      this.searchValue = item.description;
      this.searchWordList = [];
      this.searchFunc();
    },

    /*搜索输入处理*/
    onSearchInput() {
      if (this.searchValue.length > 2) {
        this.getSearchSuggestions();
      } else {
        this.searchWordList = [];
      }
    },

    /*获取搜索建议*/
    getSearchSuggestions() {
      const self = this;
      if (!this.autocompleteService) return;

      const request = {
        input: this.searchValue,
        types: ['establishment', 'geocode']
      };

      this.autocompleteService.getPlacePredictions(request, function(predictions, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
          self.searchWordList = predictions.slice(0, 5); // 限制显示5个建议
        } else {
          self.searchWordList = [];
        }
      });
    },

    /*监听键盘事件*/
    keyupFunc(e) {
      /*如果已经有搜索内容，按下向下的键盘*/
      if (e.key == 'ArrowDown') {
        if (this.searchWordList.length > 0) {
          if (this.searchlist_index == null) {
            this.searchlist_index = 0;
          } else {
            if (this.searchlist_index >= this.searchWordList.length) {
              this.searchlist_index = 0;
            } else {
              this.searchlist_index++;
            }
          }
        }
        return;
      }

      /*如果已经有搜索内容，按下向上的键盘*/
      if (e.key == 'ArrowUp') {
        if (this.searchWordList.length > 0) {
          if (this.searchlist_index == null) {
            this.searchlist_index = this.searchWordList.length - 1;
          } else {
            if (this.searchlist_index <= 0) {
              this.searchlist_index = this.searchWordList.length - 1;
            } else {
              this.searchlist_index--;
            }
          }
        }
        return;
      }

      /*如果搜索有数据，选中也有值，则直接赋值*/
      if (e.key == 'Enter' && this.searchWordList.length > 0 && this.searchlist_index != null) {
        this.searchValue = this.searchWordList[this.searchlist_index].title;
        this.searchWordList = [];
        this.searchlist_index = null;
        return;
      }

      /*判断键盘敲的是字母*/
      if (e.key.length == 1) {
        if (this.searchValue.length < 1) {
          this.searchWord += e.key;
          this.getSearchWord(this.searchWord);
        } else {
          this.getSearchWord(this.searchValue);
        }
      } else {
        if (e.key == 'Backspace') {
          if (this.searchValue.length < 1) {
            this.searchWord = this.searchWord.substr(0, this.searchWord.length - 1);
            this.getSearchWord(this.searchWord);
          } else {
            this.getSearchWord(this.searchValue);
          }
        } else if (e.key == 'Process' || e.key == 'Enter') {
          if (this.searchValue.length > 0) {
            this.searchWord == '';
          }
          this.getSearchWord(this.searchValue);
        }
      }
    },


    /*搜索关键字*/
    searchFunc() {
      const self = this;

      self.searchWordList = [];
      self.searchlist_index = null;

      if (self.is_city) {
        self.is_city = false;
      }
      if (self.searchValue == '') {
        self.$message.error('请填写搜索的内容!');
        return;
      }

      // 清除之前的标记
      self.clearMarkers();

      // 使用谷歌地图Places API搜索
      const request = {
        query: self.searchValue,
        fields: ['name', 'geometry', 'formatted_address', 'place_id'],
        locationBias: self.map.getCenter()
      };

      self.placesService.textSearch(request, function(results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          self.searchList = results.slice(0, 9); // 限制显示9个结果

          // 为每个搜索结果添加标记
          results.slice(0, 9).forEach((place, index) => {
            const marker = new google.maps.Marker({
              position: place.geometry.location,
              map: self.map,
              title: place.name,
              icon: self.createMarkerIcon(index)
            });

            // 添加点击事件
            marker.addListener('click', function() {
              self.choseItem(place, index);
            });

            self.markers.push(marker);
          });

          // 如果搜索结果不为空，调整地图视图以显示所有标记
          if (results.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            results.slice(0, 9).forEach(place => {
              bounds.extend(place.geometry.location);
            });
            self.map.fitBounds(bounds);
          }
        } else {
          self.$message.error('搜索失败，请重试');
          self.searchList = [];
        }
      });
    },

    /*创建自定义标记图标*/
    createMarkerIcon(index) {
      return {
        url: this.marker10_url,
        scaledSize: new google.maps.Size(27, 33),
        anchor: new google.maps.Point(13, 33)
      };
    },

    /*清除所有标记*/
    clearMarkers() {
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.markers = [];
    },


    /*选择地点*/
    choseItem(item, _index) {
      const self = this;
      self.select_address = _index;

      // 移动地图到选中位置
      self.map.panTo(item.geometry.location);
      self.map.setZoom(13);

      // 清除之前的选中标记
      if (self.marker_temp) {
        self.marker_temp.setMap(null);
      }

      // 创建新的选中标记
      self.marker_temp = new google.maps.Marker({
        position: item.geometry.location,
        map: self.map,
        title: item.name,
        icon: {
          url: self.marker10_url,
          scaledSize: new google.maps.Size(27, 33),
          anchor: new google.maps.Point(13, 33)
        },
        zIndex: 1000
      });

      // 添加点击事件
      self.marker_temp.addListener('click', function() {
        self.choseItem(item, _index);
      });

      // 格式化返回数据，兼容原来的数据结构
      const result = {
        location: {
          lat: item.geometry.location.lat(),
          lng: item.geometry.location.lng()
        },
        name: item.name,
        address: item.formatted_address, // 兼容原来的 address 属性
        formatted_address: item.formatted_address,
        title: item.name, // 兼容原来的 title 属性
        place_id: item.place_id
      };
      console.log('地图选择 result', result)

      self.$emit('chose', result);
    },

  }
};
</script>

<style scoped="">
.getpoint-container {
  width: 100%;
}

.search-container {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
}

.search-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #409eff;
}

.search-btn {
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.search-btn:hover {
  background-color: #66b1ff;
}

.search-suggestions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dcdfe6;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.suggestion-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.suggestion-item:hover {
  background-color: #f5f7fa;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.map-container {
  border: 1px solid #dddddd;
  overflow: hidden;
  position: relative;
}
#mapContainer {
  min-width: 500px;
  min-height: 500px;
  cursor: crosshair;
}

#cur_city {
  position: relative;
}
#cur_city .map-header-box {
  padding: 4px 10px;
  background: #409eff;
  color: #ffffff;
}
#cur_city #city {
  position: absolute;
  width: 400px;
  height: 500px;
  left: 0;
  z-index: 10;
  overflow-y: auto;
  border: 1px solid #409eff;
  background: #ffffff;
}
#cur_city .map-header-box .btn-city {
  color: #ffffff;
}
#cur_city .close {
  position: absolute;
  width: 30px;
  height: 30px;
  padding: 0;
  line-height: 30px;
  text-align: center;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  border: 1px solid #cccccc;
  cursor: pointer;
}
#cur_city .city_class,
#cur_city .city_container {
  padding: 0 20px;
}
.city_container_left {
  font-weight: bold;
}
#cur_city .city_name {
  margin-right: 10px;
  cursor: pointer;
}
#cur_city .city_container_right .city_name:hover {
  color: #409eff;
}

.map-city-list {
  position: absolute;
  width: 200px;
  top: 0;
  left: -200px;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  overflow: auto;
}
.map-city-list.open {
  left: 0;
}
.map-city-list .item {
  padding: 10px;
  border-bottom: 1px solid #dddddd;
  cursor: pointer;
}
.map-city-list .item .index-box {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  margin-top: 2px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background: #ffa500;
  color: #ffffff;
}
.map-city-list .item.active {
  background: rgba(64, 157, 255, 0.1);
}
.map-city-list .title {
  line-height: 24px;
  font-size: 14px;
  color: #000000;
}
.map-city-list .address {
  line-height: 20px;
  font-size: 12px;
  color: #888888;
}
.getpoint-container .search-box {
  padding: 0 8px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.getpoint-container .search-word-list {
  position: absolute;
  background: #ffffff;
  top: 36px;
  z-index: 99;
  border: 1px solid #409eff;
  border-radius: 0 0 6px 6px;
}
.getpoint-container .search-word-list li {
  padding: 0 16px;
  color: #333333;
  cursor: pointer;
}
.getpoint-container .search-word-list li:hover,
.getpoint-container .search-word-list li.curr {
  background: #d9eafc;
}
</style>



// WEBPACK FOOTER //
// src/components/map/GetPointGmap.vue